// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CreateUpdateCarbonEmissionProduct-styles___paper--Df4Nj {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
  display: flex;
  flex-direction: column;
}

  .components-CreateUpdateCarbonEmissionProduct-styles___paper--Df4Nj svg {
    font-size: 18px;
    right: 11px;
    top: calc(50% - 8px);
  }

.components-CreateUpdateCarbonEmissionProduct-styles___selectWrapper--aZ7E3 {
  margin-right: 32px;
}

.components-CreateUpdateCarbonEmissionProduct-styles___button--ie1vN {
  width: 200px;
}
`, "",{"version":3,"sources":["webpack://./components/CreateUpdateCarbonEmissionProduct/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AAOxB;;EALE;IACE,eAAe;IACf,WAAW;IACX,oBAAoB;EACtB;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n  display: flex;\n  flex-direction: column;\n\n  svg {\n    font-size: 18px;\n    right: 11px;\n    top: calc(50% - 8px);\n  }\n}\n\n.selectWrapper {\n  margin-right: 32px;\n}\n\n.button {\n  width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-CreateUpdateCarbonEmissionProduct-styles___paper--Df4Nj`,
	"selectWrapper": `components-CreateUpdateCarbonEmissionProduct-styles___selectWrapper--aZ7E3`,
	"button": `components-CreateUpdateCarbonEmissionProduct-styles___button--ie1vN`
};
module.exports = ___CSS_LOADER_EXPORT___;
